<template>
	<v-app id="app">
		<router-view />
		<div id="gerarPoligono" />

		<MessageContainer />
		<Portal selector="body">
			<Messages />
		</Portal>

		<!-- Visualizador de mapa do WalterIA: montado na raiz do app (uma única vez,
		     nunca destruído ao trocar de rota) para manter UMA só instância Mapbox
		     durante toda a sessão. Recriar o mapa faz os plantios ficarem pretos:
		     no ambiente alvo só a 1ª instância Mapbox da página renderiza as cores. -->
		<MapViewer />

		<RelatorioInventarioFlorestalLegacy v-if="getInventoryReportIntention" />
		<RelatorioOrdemDeServicoLegacy v-if="getServiceOrderReportIntention" />
		<RelatorioSortimento v-if="getAssortmentReportIntentation" />
	</v-app>
</template>

<script>
import { Portal } from '@linusborg/vue-simple-portal'

import { mapGetters } from 'vuex'
import MessageContainer from './components/MessageContainer/MessageContainer'
import Messages from './components/ui/message/Messages.vue'
import MapViewer from './views/WalterIA/components/MapViewer.vue'
import RelatorioInventarioFlorestalLegacy from './views/Relatorios/InventarioFlorestal/RelatorioInventarioFlorestalLegacy.vue'
import RelatorioOrdemDeServicoLegacy from './views/Relatorios/OrdemDeServico/RelatorioOrdemServicoLegacy.vue'
import RelatorioSortimento from './views/Relatorios/Sortimento/RelatorioSortimento.vue'

export default {
	name: 'App',
	components: {
		MessageContainer,
		RelatorioInventarioFlorestalLegacy,
		RelatorioOrdemDeServicoLegacy,
		RelatorioSortimento,
		Messages,
		Portal,
		MapViewer,
	},
	computed: {
		...mapGetters('moduleReports', [
			'getInventoryReportIntention',
			'getServiceOrderReportIntention',
			'getAssortmentReportIntentation',
		]),
	},
	mounted() {
		const idioma =
			localStorage.getItem('idioma') != null
				? localStorage.getItem('idioma')
				: navigator.language.substring(0, 2).toLowerCase()
		if (idioma !== 'pt' && idioma !== 'es' && idioma !== 'en') {
			localStorage.removeItem('idioma')
			localStorage.setItem('idioma', 'pt')
		} else {
			localStorage.setItem('idioma', idioma)
		}
		this.$i18n.locale = idioma
	},
}
</script>

<style scoped>
@import url('./global.css');

#app {
	height: 100vh;
	width: 100%;
	font-family: 'Open Sans', sans-serif;
}
</style>
